import React from 'react'

const MoreEdit = (props) => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill={props.color ? props.color : '#000000'}
         xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M6 12C2.68629 12 -7.24234e-07 9.31371 0 6C7.24234e-07 2.68629 2.68629 -7.24234e-07 6 0C9.31371 7.24234e-07 12 2.68629 12 6C12 9.31371 9.31371 12 6 12ZM6 10.8C3.34903 10.8 1.2 8.65097 1.2 6C1.2 3.34903 3.34903 1.2 6 1.2C8.65097 1.2 10.8 3.34903 10.8 6C10.8 8.65097 8.65097 10.8 6 10.8Z"
        />
        <path
            d="M7.58417 5.38507L4.9667 8.00254L4.34343 8.0592C4.19954 8.07228 4.079 7.95174 4.09208 7.80785L4.14874 7.18458L6.76621 4.56711L7.58417 5.38507Z"
        />
        <path
            d="M6.9298 4.40352L7.42058 3.91274C7.51093 3.82239 7.65741 3.82239 7.74776 3.91274L8.23854 4.40351C8.32889 4.49386 8.32889 4.64035 8.23854 4.7307L7.74776 5.22148L6.9298 4.40352Z"
        />
    </svg>
)

export default MoreEdit
